<breadcrumb-item-view class="back" *ngIf="showMobileBackButton && items?.length > 1">
	<button
		class="back-button"
		(click)="onBack()"
		attr.aria-label="{{'common_back'| translate}}"
		mat-icon-button
	>
		<mat-icon class="ficon-arrow-left"></mat-icon>
	</button>
</breadcrumb-item-view>

<ng-content></ng-content>
